var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropdownMenu',{attrs:{"items":_vm.items},on:{"choose":_vm.handleChoice}},[_c('FormButton',{attrs:{"variant":_vm.ButtonVariants.SECONDARY}},[_c('Icon',{staticClass:"size-4 pointer-events-none",attrs:{"icon":_vm.localeIcon}}),_c('span',{staticClass:"block pl-3 text-sm font-medium"},[_vm._v(_vm._s(_vm.$t("locale.current")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }